export const infoColor = {
  'EM NEGOCIAÇÃO': '#9370DB',
  'EM ANÁLISE PARA FECHAMENTO': '#00CBFF',
  'LAYOUT ENCAMINHADO': '#8FA197',
  'CHAMADO NOVO': '#95C620',
  'FEEDBACK DA PROPOSTA': '#FFA07A',
  'PRIMEIRO CONTATO': '#FF9900',
  'VENDA CONVERTIDA (PEDIDO)': '#20B2AA',
  PERDIDO: '#F11900',
  'AGUARDANDO APROVAÇÃO CLIENTE': '#378BBF',
  'AGUARDANDO PAGAMENTO': '#A7A7A7',
  'EM APROVAÇÃO': '#045cffa9',
  'LIBERAÇÃO VENDEDOR': '#FFD700',
  'LIBERAÇÃO GERENTE': '#FF33c2',
  'LIBERAÇÃO COMPRA': '#ac33c1',
  'EM PRODUÇÃO': '#FF6000',
  'NÃO ENVIADO PARA APROVAÇÃO': '#FFb112',
  'ANÁLISE DE CRÉDITO': '#BEb699',
  'AGUARDANDO APROVAÇÃO COMPRE GANHE': '#FFb162',
}
